angular.module('iconoglobe')
.directive('audioPlayer', function(){
  return {
    restrict: "E",
    templateUrl: 'app/min/audio-player.html',
    replace: true,
    controllerAs: 'ap',
    controller: function($scope){
      var ap = this;
      ap.createAudio = function(){
        ap.track = {};
        ap.audiorange = 0;
        ap.track.audio = new Audio($scope.path + $scope.audio.name);
        ap.track.stopped = true;
        angular.element(ap.track.audio).on('loadedmetadata', function(){
          ap.track.duration = Math.round(ap.track.audio.duration);
          ap.track.time = ap.calculateTime(ap.track.duration);
          ap.track.pos = 0;
        });
        
        angular.element(ap.track.audio).on('timeupdate', function(){
          var time = Math.round(this.currentTime)
          ap.track.pos = ap.calculateTime(time);
          time = time - 6;
          ap.track.pointer = {
            left: (time/ap.track.duration)*100 + "%"
          }
          $scope.$apply();
        });
        
        ap.track.pointer = {
          left: '-6px'
        };
        // ap.track.chaser = {
        //   width: 0
        // };
      }
      ap.createAudio();
      
      ap.calculateTime = function(time){
        var hours = Math.floor(time / 3600);
        if(hours >= 1) {
          var minutes = Math.floor(time - (hours * 3600));
        } else {
          var minutes = Math.floor(time / 60);
        }
        if(minutes >= 1){
          var seconds = time - (minutes * 60);
        } else {
          var seconds = time;
        }
        
        var res = (hours) ? hours + "." + minutes + "." + seconds : minutes + "." + seconds;
        return res;
      }
      ap.playAudio = function(e){
        ap.track.audio.play();
        ap.track.playing = true;
        ap.track.stopped = false;
      }
      
      ap.pauseAudio = function(e){
        ap.track.playing = false;
        ap.track.audio.pause();
      }
      ap.stopAudio = function(e){
        ap.track.audio.pause();
        ap.track.audio.currentTime = 0;
        ap.track.playing = false;
        ap.track.stopped = true;
        ap.track.pointer = {
          left: '-6px'
        };
      }
      ap.updatePos = function(time){
        ap.track.pos = ap.calculateTime(time);
        
        ap.track.audio.currentTime = time;
        time = time - 6;
        ap.track.pointer = {
          left: (time/ap.track.duration)*100 + "%"
        }
        // ap.track.chaser = {
        //   width: (time/ap.track.duration)*100 + "%"
        // }
      }
      $scope.$on('stop audio', function(e){
        if(ap.track.playing) ap.pauseAudio();
      });
    },
    scope: {
      audioarray: "=audioarray",
      pos: "=pos",
      audio: "=audio",
      path: "=path"
    }
  }
});